import axios from "axios";
import Links from "../constants/Links";


/**
 * @description This is the Global API hook, for handling Global settings (C) 2021-2023
 * @type {{fetch: (function(): Promise<AxiosResponse<any>>), update: (function(*): Promise<AxiosResponse<any>>), updateEmailConfig: (function(*): Promise<AxiosResponse<any>>), updateLogo: (function(*): Promise<AxiosResponse<any>>)}}
 */
const Global = {
    /**
     * @description Returns global settings object which contains school global informtaion, email configuration and more
     * @returns {Promise<AxiosResponse<*>>}
     */
    fetch: async () => {
        return axios.get(Links.global.fetch)
    },


    /**
     * update global infomation
     * @param {object} data 
     * @returns 
     */
    update: async (data) => {
        return axios.post(Links.global.update, data)
    },


    /**
     * handle updating of the system logo (.jpg, .jpeg, .png)
     * @param {object} data 
     * @returns {Promise<Blob>}
     */
    updateLogo: async (data) => {
        return axios.post(Links.global.updateLogo, data)
    },

    /**
     * @description Updates email config
     * @param {object} data the object containing the properties to be updated. the properties are : emailPassword, emailUsername, emailHost, emailPort
     * @returns {Promise<AxiosResponse<any>>}
     */
    updateEmailConfig: async (data) => {
        return axios.post(Links.global.updateEmailConfig, data)
    },

    /**
     * @description Updates global options
     * @param {object} data an object containing the following properties: 
     * examSubCommitteeEnabled (boolean), facultyTitle(String), departmentTitle(String)
     * @returns {Promise<AxiosResponse<any>>}
     */
    updateOptions: async (data) => {
        return axios.post(Links.global.updateOptions, data)
    },


    /**
     * @description - enable global notification
     * @param {object} data - enable --> yes : disable --> no
     * @returns {Promise<boolean>}
    */
    enableGlobalNotification: async (data) => {
        return axios.post(Links.global.enableNotification, data); 
    }
}

export default Global